import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { SiteLayout } from "@/components/site/SiteLayout";
import { AboutPage } from "@/pages/AboutPage";
import { AdminSubmissionsPage } from "@/pages/AdminSubmissionsPage";
import { CareersPage } from "@/pages/CareersPage";
import { ContactPage } from "@/pages/ContactPage";
import { HomePage } from "@/pages/HomePage";
import { HowItWorksPage } from "@/pages/HowItWorksPage";
import { PartnersPage } from "@/pages/PartnersPage";
import { PlatformPage } from "@/pages/PlatformPage";
import { PrivacyPolicyPage } from "@/pages/PrivacyPolicyPage";
import { RecruiterNetworkPage } from "@/pages/RecruiterNetworkPage";
import { SolutionsPage } from "@/pages/SolutionsPage";
import { TermsOfServicePage } from "@/pages/TermsOfServicePage";
import { VendorNetworkPage } from "@/pages/VendorNetworkPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/recruiter-network" element={<RecruiterNetworkPage />} />
          <Route path="/vendor-network" element={<VendorNetworkPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/admin/submissions" element={<AdminSubmissionsPage />} />
        </Routes>
      </SiteLayout>
    </BrowserRouter>
  );
}

export default App;
